import { useEffect } from "react";

import { Checkbox, Divider, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@mui/material";

const workloadKeys = ["kube-dns", "fluentbit-gke", "cilium", "gke-metadata-server", "frontend"];

interface WorkloadSelectorProps {
  value: string[];
  onChange: (value: string[]) => void;
  selectAllByDefault?: boolean;
}

const WorkloadSelector = ({ value = [], onChange, selectAllByDefault = true }: WorkloadSelectorProps) => {
  const allValuesAreSelected = workloadKeys.every((v) => value.includes(v));

  const handleSelect = (workload: string) => {
    if (!value) return;
    const newSelectedValues = value.includes(workload) ? value.filter((v) => v !== workload) : [...value, workload];
    onChange(newSelectedValues);
  };

  const handleSelectAll = () => {
    const newSelectedValues = allValuesAreSelected ? [] : workloadKeys;
    onChange(newSelectedValues);
  };

  useEffect(() => {
    if (selectAllByDefault) {
      onChange(workloadKeys);
    }
  }, [selectAllByDefault, onChange]);

  return (
    <FormControl>
      <InputLabel size="small">Workloads</InputLabel>
      <Select
        size="small"
        multiple
        value={value}
        label="Workloads"
        sx={{
          width: 200,
        }}
        renderValue={(selected) => selected.join(", ")}
      >
        <MenuItem onClick={handleSelectAll}>
          <Checkbox checked={allValuesAreSelected} size="small" />
          <ListItemText primary="Select All" />
        </MenuItem>
        <Divider />
        {workloadKeys.map((key) => (
          <MenuItem
            key={key}
            value={key}
            onClick={() => {
              handleSelect(key);
            }}
          >
            <Checkbox checked={value.includes(key)} size="small" />
            <ListItemText primary={key} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default WorkloadSelector;
